import { FC } from 'react';

import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from '../../../shared/ui/TableV2';

import { Snippet } from '@distribute/shared/types';

import { SnippetRow } from './SnippetRow';
import { SnippetCard } from './SnippetCard';

import { useView } from '../hooks';

type Props = {
  snippets: Snippet[];
};

const SnippetsGrid: FC<Props> = ({ snippets }) => {
  return (
    <div className="sm:-mx-1 grid gap-5 sm:grid-cols-[repeat(auto-fill,minmax(320px,1fr))] grid-cols-[repeat(auto-fill,minmax(340px,1fr))]">
      {snippets.map((snippet) => (
        <SnippetCard key={snippet.id} snippet={snippet} />
      ))}
    </div>
  );
};

const SnippetsList: FC<Props> = ({ snippets }) => {
  return (
    <div className="sm:-mx-3 overflow-x-auto -mx-2 px-2 pb-2 -mb-2">
      <Table className="table-fixed">
        <TableHeader>
          <TableHeaderCell className="sm:w-66 w-135">Name</TableHeaderCell>
          <TableHeaderCell className="w-34">Type</TableHeaderCell>
          <TableHeaderCell className="w-34">Created</TableHeaderCell>
          <TableHeaderCell className="w-14">Owner</TableHeaderCell>
          <TableHeaderCell className="w-15" />
        </TableHeader>
        {snippets.map((snippet) => {
          return (
            <>
              <TableRow key={snippet.id + 'gap'} className="h-2" />
              <SnippetRow key={snippet.id} snippet={snippet} />
            </>
          );
        })}
      </Table>
    </div>
  );
};

export const SnippetsView: FC<Props> = ({ snippets }) => {
  const { view } = useView();

  return view === 'grid' ? (
    <SnippetsGrid snippets={snippets} />
  ) : (
    <SnippetsList snippets={snippets} />
  );
};
